module.exports = __webpack_public_path__ + "static/fooled-by-randomness-8ae94ef22c09986611eb3517d604c7f8.jpg";